import React, { useState, Fragment, useEffect } from 'react'
import {
    Card, Form, Col, Row, ListGroup, ListGroupItem, Dropdown
} from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { aggregateByYear, downloadCSV} from '../utils/utils';


export const CardTimeseriesSelection = ({ charts, setCharts, overallData, overallFueltypes, fuelTypeInfo, scenario, fleet }) => {
    const [csvHeaders, setCsvHeaders] = useState([])
    const [csvKeys, setCsvKeys] = useState([])
    useEffect(()=>{
        // const hasnshipcolumn = overallData.some(row => 'nshipsfuel')
        const _keys = ["year", "month", "capacity", "Tank-To-Wake", "Well-To-Tank", "capex", "capex_cumsum", "opex", "opex_cumsum", "nbunkering_relative", "nships", "nships_relative" ,"average_speed_kts", "el_energy", "trips"]
        const _headers = ["Year", "Month", "Transport capacity [ton.mile]", "Tank to wake CO2 emission [kTon]", "Well to tank CO2 emission [kTon]", "Capital expenditure [€]", 
        "Cumulative capital expenditure [€]", "Operational expenditure [€]", "Cumulative operational expenditure [€]", "Number of bunkerings relative to first month [%]", "Average number of ships sailing", 
        "Average number of ships sailing relative to first month [%]", "Average speed [kn]", "Total electric energy demand [GWh]", "Number of trips"]
        overallFueltypes.forEach(element => { // adds additional columns to overalldata
            _keys.push(`consumption.${element.name}`)
            _headers.push(`Consumption ${fuelTypeInfo[element.name].short_display_name} [MWh]`)
        })
        overallFueltypes.forEach(element => {
            _keys.push(`fuel_price.${element.name}`)
            _headers.push(`Fuel price ${fuelTypeInfo[element.name].short_display_name} [€/kWh]`)
        })
        //if (hasnshipcolumn) {       
        overallFueltypes.forEach(element => {
            _keys.push(`techshare.${element.name}`)
            _headers.push(`Technology share ${fuelTypeInfo[element.name].short_display_name} [%]`)
        })//}
        
        setCsvHeaders(_headers)
        setCsvKeys(_keys)
    },[overallFueltypes, fuelTypeInfo, overallData])

    //const [showWarning, setShowWarning] = useState(false)
    const [nSelected, setNSelected] = useState(4)

    const handleClick = (selectedC) => {

        let _nS = nSelected
        if (!selectedC.checked)
            _nS = _nS + 1
        else
            _nS = _nS - 1

        if (_nS > 12) {
            setCharts([...charts])
            toast.error('Max number of charts is selected!', {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setCharts([...charts])
            setNSelected(12)
        }
        else {
            let _charts = charts.filter(c => c.id !== selectedC.id)
            selectedC.checked = !selectedC.checked
            let final = [..._charts, selectedC]

            final = final.sort((a, b) => a.id - b.id)
            setCharts([...final])
            setNSelected(_nS)
        }

    }

    return (

        <Fragment>
            <Card
                style={{
                    position: 'absolute',
                    top: 255,
                    left: 20,
                    width: '20vw',
                    alignContent: 'center'
                }}>
                {/* {showWarning ?
                    <Row>

                        <Col><h6 style={{ margin: 20 }}>Too many charts are selected! </h6></Col>
                    </Row>
                    :
                    <></>
                } */}

                {/* <Card.Body className="d-flex justify-content-left"> */}
                <ListGroup variant="flush">
                <ListGroupItem>

                <Row>
                    <Col><h6>Select charts:</h6></Col>
                </Row>
                    <Form>
                        {
                            charts.map((c, idx) =>
                                <Form.Check // prettier-ignore
                                    type='checkbox'
                                    checked={c.checked}
                                    key={`chartcheck-${idx}`}
                                    onChange={() => handleClick(c)}
                                    id={c.id}
                                    label={c.name}
                                />
                            )
                        }
                    </Form>
                </ListGroupItem>
                <ListGroupItem>
                    <Dropdown className='w-100 mt-2'>
                        <Dropdown.Toggle id="dropdown-basic" className='w-100'>
                            <FaDownload /> Download data
                        </Dropdown.Toggle>

                        <Dropdown.Menu className='w-100'>
                            <Dropdown.Item 
                            onClick={()=>{
                                downloadCSV(`${scenario.region}-${scenario.name}-${fleet.fleet}-monthly.csv`, overallData, csvKeys, csvHeaders)}}>Download monthly totals as CSV</Dropdown.Item>
                            <Dropdown.Item 
                            onClick={()=>{                                
                                const overallyearlyData = aggregateByYear(overallData, {
                                rules: {
                                    year: "skip",
                                    month: "drop",
                                    Fuel_price: "average",
                                    average_speed_kts: "average",
                                    capacity_relative: "average",
                                    consumption: "objectSum",
                                    techshare: "objectAverage",
                                    fuel_price:"objectAverage",
                                    nbunkeringrelative:"average",
                                    payload_avg:"average",
                                    name: "drop",
                                    day: "drop",
                                    month_days:"drop",
                                    nshipsfuel:"objectAverage",
                                    capex_cumsum: "max",
                                    opex_cumsum: "max"
                                }
                                });

                                downloadCSV(`${scenario.region}-${scenario.name}-${fleet.fleet}-yearly.csv`, overallyearlyData, csvKeys, csvHeaders)}}>Download yearly totals as CSV</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </ListGroupItem>
                </ListGroup>
                {/* </Card.Body> */}
            </Card>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Fragment>

    )
}